import React from "react";
import { Backdrop, Box, Typography } from "@mui/material";
import offerCheckIcon from "../../assets/images/check-offer-loader.gif";

const OfferCheckLoader = ({
  open,
  content,
}: {
  open: boolean;
  content: string;
}) => (
  <Backdrop open={open} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        px: 2, 
      }}
    >
      <Box
        sx={{
          background: "#fff",
          borderRadius: 2,
          boxShadow: 2,
          p: { xs: 3, sm: 5 },
          width: "100%",
          maxWidth: 450,
          textAlign: "center",
        }}
      >
        <Box>
          <img
            src={offerCheckIcon}
            alt="check offer icon"
            style={{
              width: "100%",
              maxWidth: 310,
              height: 100,
              objectFit: "contain",
              display: "inline-block",
            }}
          />
        </Box>
        <Typography 
          sx={{ 
            fontWeight: 700, 
            mb: 1, 
            fontSize: { xs: "1.25rem", sm: "1.5rem" }
          }}
        >
          {content}
        </Typography>
      </Box>
    </Box>
  </Backdrop>
);

export default OfferCheckLoader;
